import { LocationStoreView } from '../../types/locations';
import { LocationEntityLink } from '@mark43/cad-api';
import { HStack, Icon, TextProps, Text } from '@cad-arc';
import { useMemo, CSSProperties } from 'react';
import { Tooltip } from '../../../common/components/tooltip';
import { CommonSize, getBasicCommonSize } from '../../../common/helpers/utils';

const D_AREA_MAX_WITH_PX = 300;
const Z_INDEX_OVERRIDE = 1801; // Needs to be larger than tooltip zIndex

export function LocationSelectDispatchAreaDisplay({
    location,
    textProps,
    size,
}: {
    location: LocationStoreView;
    textProps?: TextProps;
    size?: CommonSize;
}) {
    const entityLink: LocationEntityLink | undefined = location.entityLinks?.[0] || {};
    const { policeDispatchArea, fireDispatchArea, medicalDispatchArea } = entityLink;

    const basicCommonSize = getBasicCommonSize(size);

    const textStyle = useMemo(() => {
        const dBoxAreasCount = [policeDispatchArea, fireDispatchArea, medicalDispatchArea].filter(
            Boolean
        ).length;
        const maxWithPx = Math.round(D_AREA_MAX_WITH_PX / dBoxAreasCount);
        const styles: CSSProperties = {
            maxWidth: `${maxWithPx}px`,
            maxHeight: '48px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: size == 'lg' ? '16px' : '14px',
        };
        return styles;
    }, [policeDispatchArea, fireDispatchArea, medicalDispatchArea, size]);

    return (
        <HStack spacing={2} zIndex={Z_INDEX_OVERRIDE}>
            {policeDispatchArea && (
                <Tooltip overlay={policeDispatchArea}>
                    <HStack alignContent="center" spacing={0.5}>
                        <Icon icon="Police" color="icon.default" size={basicCommonSize} />
                        <Text
                            color="text.secondary"
                            {...textProps}
                            style={{
                                ...textStyle,
                                ...textProps?.style,
                            }}
                        >
                            {policeDispatchArea}
                        </Text>
                    </HStack>
                </Tooltip>
            )}
            {fireDispatchArea && (
                <Tooltip overlay={fireDispatchArea}>
                    <HStack alignContent="center" spacing={0.5}>
                        <Icon icon="Fire" color="icon.default" size={basicCommonSize} />
                        <Text
                            color="text.secondary"
                            {...textProps}
                            style={{
                                ...textStyle,
                                ...textProps?.style,
                            }}
                        >
                            {fireDispatchArea}
                        </Text>
                    </HStack>
                </Tooltip>
            )}
            {medicalDispatchArea && (
                <Tooltip overlay={medicalDispatchArea}>
                    <HStack alignContent="center" spacing={0.5}>
                        <Icon icon="EMS" color="icon.default" size={basicCommonSize} />
                        <Text
                            color="text.secondary"
                            {...textProps}
                            style={{
                                ...textStyle,
                                ...textProps?.style,
                            }}
                        >
                            {medicalDispatchArea}
                        </Text>
                    </HStack>
                </Tooltip>
            )}
        </HStack>
    );
}
